package music.jammers.client.shared.app.di

import music.jammers.client.shared.analytics.screen.ScreenAnalytics
import music.jammers.client.shared.analytics.screen.ScreenAnalyticsImpl
import org.koin.dsl.module

val analyticsSharedModule = module {
    single<ScreenAnalytics> {
        ScreenAnalyticsImpl(
            firebaseAnalytics = get(),
        )
    }
}